import React from 'react';

const AboutSection: React.FC = () => {
  const stats = [
    { number: '0€',    label: 'Budget publicité',       sub: 'La preuve qu\'un bon système bat n\'importe quel algorithme.' },
    { number: '750k+', label: 'Vues mensuelles',         sub: 'Une stratégie de contenu qui travaille sur le long terme.' },
    { number: '∞',     label: 'Rigueur + créativité',    sub: 'Je ne me contente pas de faire joli, je fais rentable.' },
  ];

  return (
    <section className="section-lg bg-off-white">
      <div className="container mx-auto px-4" style={{ maxWidth: 960 }}>

        {/* ── Header ──────────────────────────────────────── */}
        <div className="reveal mb-14">
          <div className="flex mb-6">
            <span className="reveal-child badge-pill">
              <span className="badge-pill-dot" />
              Pourquoi moi
            </span>
          </div>
          <h2
            className="reveal-child font-display text-foreground leading-[1.1]"
            style={{ fontSize: 'clamp(2.25rem, 5vw, 3.75rem)' }}
          >
            12 ans à analyser des risques, une vie à créer.
          </h2>
        </div>

        {/* ── Bio ─────────────────────────────────────────── */}
        <div className="reveal space-y-5 mb-16 max-w-2xl">
          <p className="reveal-child text-lg text-muted-foreground leading-relaxed">
            Avant de lancer Glow Lab, j'ai passé 12 ans dans l'assurance à décortiquer des systèmes complexes et des dossiers à 150 000 €.
          </p>
          <p className="reveal-child text-lg text-muted-foreground leading-relaxed">
            La rigueur, la structure et la précision sont dans mon ADN.
          </p>
          <p className="reveal-child text-lg text-muted-foreground leading-relaxed">
            Puis j'ai tout plaqué pour construire Majoliepeau. Sans budget publicité, sans équipe, juste avec un système organique puissant.
          </p>
          <p className="reveal-child text-lg text-muted-foreground leading-relaxed">
            Chaque automatisation, chaque tunnel que je vais installer pour toi,{' '}
            <strong className="text-foreground">je l'ai d'abord testé (et validé) sur ma propre marque.</strong>
          </p>
        </div>

        {/* ── Stats — editorial strip ──────────────────────── */}
        <div
          className="reveal grid grid-cols-1 md:grid-cols-3"
          style={{
            borderTop: '1px solid hsl(var(--border))',
            borderBottom: '1px solid hsl(var(--border))',
          }}
        >
          {stats.map((s, i) => (
            <div
              key={i}
              className="reveal-child text-center py-10 px-4"
              style={{
                borderRight:
                  i < stats.length - 1
                    ? '1px solid hsl(var(--border))'
                    : undefined,
              }}
            >
              <p
                className="stat-number mb-3"
                style={{ fontSize: 'clamp(2.25rem, 5vw, 3.75rem)' }}
              >
                {s.number}
              </p>
              <p className="font-body text-xs font-semibold uppercase tracking-widest text-foreground/80 mb-2">
                {s.label}
              </p>
              <p className="font-body text-xs text-muted-foreground leading-relaxed">{s.sub}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default AboutSection;
